/* ============================================================
   MediNeeds — Product page (PDP) interactions.
   Lives in an EXTERNAL asset (loaded with <script src ... defer>) instead of an
   inline section <script>, so it runs reliably even where inline scripts are
   blocked by an app CSP or execute out of order — the same reason the mobile menu
   was moved to mn-home.js. Per-product data comes from a CSP-safe JSON island
   (<script type="application/json" class="mn-pdp-data">), which is data (not an
   executed script) and is therefore never blocked.
   ============================================================ */
(function () {
  'use strict';

  function initPDP(dataEl) {
    if (dataEl.dataset.mnInit) return;
    dataEl.dataset.mnInit = '1';

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var root = document.getElementById('shopify-section-' + data.sectionId) || document;
    var form = root.querySelector('#mnProductForm');
    var stage = root.querySelector('#mnStageImg');
    var idInput = root.querySelector('#mnVariantId');
    var VARIANTS = data.variants || [];
    var cartUrl = data.cartUrl || '/cart';
    var cartAddUrl = data.cartAddUrl || '/cart/add';

    /* ---------- Gallery: thumbnail → main image ---------- */
    root.querySelectorAll('[data-full]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (stage) stage.src = b.getAttribute('data-full');
        var group = b.parentNode;
        group.querySelectorAll('[data-full]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });

    /* ---------- Quantity stepper ---------- */
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = root.querySelector('#mnQty'); if (!q) return;
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    /* ---------- Variants ---------- */
    var selected = [];
    root.querySelectorAll('.pdp-variant-group').forEach(function (g, gi) {
      var a = g.querySelector('.pdp-swatch.active') || g.querySelector('.pdp-swatch');
      selected[gi] = a ? a.getAttribute('data-value') : null;
    });
    function fmt(el, val, show) { if (!el) return; if (show) { el.hidden = false; el.textContent = val; } else el.hidden = true; }
    function updateVariant() {
      if (!VARIANTS.length) return;
      var v = VARIANTS.find(function (x) { for (var i = 0; i < selected.length; i++) { if (x.options[i] !== selected[i]) return false; } return true; }) || VARIANTS[0];
      if (idInput) idInput.value = v.id;
      var pe = root.querySelector('#mnPrice'); if (pe) pe.textContent = v.price;
      fmt(root.querySelector('#mnCompare'), v.compare, v.has_compare);
      var oe = root.querySelector('#mnOff'); if (oe) { if (v.has_compare) { oe.hidden = false; oe.textContent = v.pct + '% OFF'; } else oe.hidden = true; }
      var se = root.querySelector('#mnSave'); if (se) { if (v.has_compare) { se.hidden = false; se.textContent = 'You save ' + v.save; } else se.hidden = true; }
      var sp = root.querySelector('#mnStickyPrice'); if (sp) sp.textContent = v.price;
      var ab = root.querySelector('#mnAddBtn'), al = root.querySelector('#mnAddLabel');
      if (ab) { ab.disabled = !v.available; if (al) al.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.img && stage) stage.src = v.img;
    }
    root.querySelectorAll('.pdp-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = parseInt(sw.getAttribute('data-option-index'), 10);
        selected[idx] = sw.getAttribute('data-value');
        sw.parentNode.querySelectorAll('.pdp-swatch').forEach(function (x) { x.classList.remove('active'); });
        sw.classList.add('active');
        updateVariant();
      });
    });

    /* ---------- AJAX add to cart ---------- */
    var toast = root.querySelector('#mnToast'), tT;
    function showToast() { if (!toast) return; toast.classList.add('show'); clearTimeout(tT); tT = setTimeout(function () { toast.classList.remove('show'); }, 2500); }
    function refreshCount() {
      fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = false; });
      }).catch(function () {});
    }
    function addToCart() {
      if (!form) return Promise.reject();
      var fd = new FormData(form); var ab = root.querySelector('#mnAddBtn'); if (ab) ab.disabled = true;
      return fetch(cartAddUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { showToast(); refreshCount(); if (ab) ab.disabled = false; });
    }
    if (form) form.addEventListener('submit', function (e) { if (e.submitter && e.submitter.name === 'add') { e.preventDefault(); addToCart().catch(function () { form.submit(); }); } });
    var sAdd = root.querySelector('#mnStickyAdd'), sBuy = root.querySelector('#mnStickyBuy');
    if (sAdd) sAdd.addEventListener('click', function () { addToCart().catch(function () { if (form) form.submit(); }); });
    if (sBuy) sBuy.addEventListener('click', function () { addToCart().then(function () { window.location.href = '/checkout'; }).catch(function () { if (form) form.submit(); }); });

    /* ---------- Pincode delivery check (pan-India) ---------- */
    var pinWrap = root.querySelector('.pdp-pincode');
    if (pinWrap) {
      var pinInput = pinWrap.querySelector('input');
      var pinBtn = pinWrap.querySelector('button');
      var msg = root.querySelector('.pdp-pin-msg');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'pdp-pin-msg';
        msg.setAttribute('role', 'status');
        pinWrap.parentNode.insertBefore(msg, pinWrap.nextSibling);
      }
      var okIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>';
      var errIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"/></svg>';
      function checkPin() {
        var val = (pinInput && pinInput.value || '').replace(/\D/g, '');
        if (/^[1-9][0-9]{5}$/.test(val)) {
          msg.className = 'pdp-pin-msg ok';
          msg.innerHTML = okIcon + '<span>Yes! Delivery is available at <b>' + val + '</b> — your location is eligible for pan-India delivery.</span>';
        } else {
          msg.className = 'pdp-pin-msg err';
          msg.innerHTML = errIcon + '<span>Please enter a valid 6-digit pincode.</span>';
        }
      }
      if (pinBtn) pinBtn.addEventListener('click', checkPin);
      if (pinInput) {
        pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });
        pinInput.addEventListener('input', function () { pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6); });
      }
    }

    /* ---------- Tab scroll-spy ---------- */
    var links = root.querySelectorAll('.pdp-tablink');
    if (links.length) {
      var secs = []; links.forEach(function (l) { var t = document.getElementById(l.getAttribute('href').slice(1)); if (t) secs.push(t); });
      if ('IntersectionObserver' in window && secs.length) {
        var obs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('active', l.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-140px 0px -60% 0px', threshold: 0 });
        secs.forEach(function (x) { obs.observe(x); });
      }
      links.forEach(function (l) { l.addEventListener('click', function (e) { var t = document.getElementById(l.getAttribute('href').slice(1)); if (t) { e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' }); } }); });
    }

    updateVariant();
  }

  function boot() {
    document.querySelectorAll('script.mn-pdp-data[type="application/json"]').forEach(initPDP);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
